import { render, staticRenderFns } from "./PartnerVideos.vue?vue&type=template&id=4d22c7e2&scoped=true&"
import script from "./PartnerVideos.vue?vue&type=script&lang=js&"
export * from "./PartnerVideos.vue?vue&type=script&lang=js&"
import style0 from "./PartnerVideos.vue?vue&type=style&index=0&id=4d22c7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d22c7e2",
  null
  
)

export default component.exports